<template>
  <div>
    <div style="height: 430px;background-size: 100% 100%;"
      :style="{ backgroundImage: 'url(' + require('@/assets/images/ny-bannar1.jpg') + ')' }">
      <div style="width: 1200px;margin: 0px auto;height: 100%;font-size: 16px;" class="file falign">
        <div style="width: 155px;border-right: 3px solid #fff;">
          <div :class="[{ 'mindex': mindex == i }, { 'menu': mindex != i }]" @click="getInfo(x.ID, i)"
            style="height: 40px;padding-right: 30px;text-align: right;line-height:40px;cursor: pointer;"
            v-for="(x, i) in menus">{{
              x.name }}</div>
        </div>
        <div style="flex: 1;padding-left: 90px;">
          <div style="font-size: 40px;">{{ data.title }}</div>
          <div style="margin-top: 40px;width: 50%;">{{ data.text }}</div>
          <div @click="toc"
            style="margin-top: 44px;width: 140px;height: 40px;line-height: 40px;text-align: center;background: #1e66d1;color: #fff;cursor: pointer;">
            获取完整方案</div>
        </div>
      </div>
    </div>

    <div style="width: 1200px;margin: 0px auto;">
      <div style="margin-top: 65px;font-size: 28px;text-align: center;">
        应用场景
      </div>
      <div style="margin-top: 42px;display: flex;">
        <div :class="{ 'moindex': moindex == i }" @mouseenter="moindex = i" @click="moindex = i" class="mokuai"
          style="position: relative;width: 25%;height: 340px;padding: 30px;background: #f2f3f5;cursor: pointer;"
          v-for="(x, i) in appscenario">
          <div><img :src="action + (moindex == i ? x.img : x.imgb)" style="width: 75px;height: 75px;margin: 0px auto;">
          </div>
          <div style="margin-top: 20px;font-size: 20px;font-weight: bold;text-align: center;">{{ x.title }}</div>
          <div style="margin-top: 35px;font-size: 14px;">{{ x.text }}</div>
          <div v-if="i == moindex" style="position: absolute;" class="sanjx"></div>
        </div>
      </div>

      <div
        style="position: relative;width: 100%;background: #1e66d1;color: #fff;font-size: 14px;padding:30px 50px;line-height: 25px;text-indent: 2em;">
        <img src="../../assets/images/xzwm1.jpg"
          style="width: 100%;height: 100%;position: absolute;top: 0px;left: 0px;opacity: 0.1;">
        {{ appscenario[moindex].info }}
      </div>

      <div style="margin-top: 85px;font-size: 28px;text-align: center;">
        解决方案亮点
      </div>
      <div class="file" style="margin-top: 26px;justify-content: space-between;">
        <div v-for="(x, i) in attracting" style="width: 373px;">
          <div style="background-size: 100% 100%;height: 230px;border-radius: 20px;position: relative;"
            :style="{ backgroundImage: 'url(' + action + x.img + ')' }">
            <div
              style="border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;left: 0px;width: 100%; font-size: 18px;text-align: center;height: 50px;background: #1e66d1;color: #fff;line-height: 50px;position: absolute;bottom: 0px;">
              {{ x.title }}</div>
          </div>
          <div style="font-size: 14px;margin-top: 32px;padding:0px 30px;">{{ x.text }}</div>
        </div>
      </div>

      <div style="margin-top: 100px;font-size: 28px;text-align: center;">相关产品</div>
      <div class="file" style="margin-top: 38px;font-size: 16px;justify-content: space-around;">
        <div v-for="x in data.products" @click="tod(x.title)"
          style="width: 160px;height: 130px;background: #f3f5f8;border-radius: 20px;box-shadow:rgba(176, 176, 176, 0.5) 0px 6px 10px 0px;border: 2px solid #fff;cursor: pointer;">
          <div style="margin-top: 25px;"><img :src="action + x.img" style="height: 40px;margin: 0px auto;"></div>
          <div style="margin-top:15px ;text-align: center;">{{ x.title }}</div>
        </div>
      </div>

      <div style="margin-top: 100px;font-size: 28px;text-align: center;">合作客户</div>
      <div class="file" style="margin-top: 35px;margin-bottom: 80px;justify-content:space-around;">
        <!--  -->
        <div :style="{ backgroundImage: 'url(' + require('@/assets/images/back.png') + ')' }" v-for="(x, i) in crms"
          @click="to(x.title)"
          style="width: 360px;min-height: 240px;padding:23px 40px 30px 40px;border-radius: 20px;background-size: 100% 100%;cursor: pointer;">
          <div><img :src="action + x.img" style="height: 40px;"></div>
          <div style="margin-top: 11px;font-size: 18px;font-weight: bold;">{{ x.title }}</div>
          <div style="margin-top: 30px;font-size: 14px;">{{ x.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      action: window['pathConfig'][process.env.NODE_ENV].ImgURL,
      mindex: 0,
      moindex: 0,
      menus: [],
      data: {},
      appscenario: [],
      attracting: [],
      crms: []
    }
  },
  created() {
    this.$http('/Plan/GetTypeData').then(x => {
      if (x.data.length > 0) {
        this.menus = x.data.filter(z=>z.name != '央企' && z.name != '国企')
        this.load()
      }
    })
  },
  activated() {
    // this.$http('/Plan/GetTypeData').then(x => {
    //   if (x.data.length > 0) {
    //     this.menus = x.data
    //     this.load()
    //   }
    // })
    var id = this.$route.query.id
    if (id) {
      this.menus.forEach((x, i) => {
        if (x.ID == id) {
          this.getInfo(x.ID, i)
        }
      })
    }else if(this.$route.query.index){
      var i = Number(this.$route.query.index)
      this.getInfo(this.menus[i].ID,i)
    }
  },
  methods: {
    load() {
      var id = this.$route.query.id
      if (id) {
        this.menus.forEach((x, i) => {
          if (x.ID == id) {
            this.getInfo(x.ID, i)
          }
        })
      }
      else
        this.getInfo(this.menus[0].ID, 0)
    },
    to(title) {
      this.$router.push({ name: 'crmcase', query: { id: this.menus[this.mindex].ID, title: title } })
    },
    tob(name) {
      this.$router.push({ name: name })
    },
    toc() {
      if (this.$isxj)
        window.open('https://work.weixin.qq.com/kfid/kfc54a4ebac7513c548')
      else
        window.open('https://work.weixin.qq.com/kfid/kfc31843ffccca81b46')
    },
    tod(title) {
      if (title == 'SCRM') {
        this.$router.push({ name: 'app', query: { id: '6f7ed4c5-3904-4cbb-8928-a58549418577' } })
      }
      else if (title == '会话内容存档') {
        this.$router.push({ name: 'product', query: { id: '8d1ca8da-ba06-47e3-a65d-42560a4ef864' } })
      }
      // else if (title == 'IOA零信任') {
      //   this.$router.push({ name: 'product', query: { id: 'f750cd1e-8005-438a-bafd-5cc7ef5c7d6a' } })
      // }
      else {
        this.$router.push({ name: 'product', query: { title: title } })
      }
    },
    getInfo(ID, i) {
      this.mindex = i
      this.$http('/Plan/GetDetails', { typeid: ID }).then(x => {
        if (x.length > 0) {
          this.data = x[0]
          this.appscenario = JSON.parse(this.data.appscenario)
          this.attracting = JSON.parse(this.data.attracting)
          this.crms = JSON.parse(this.data.crms)
        }
        else {
          this.data = {}
          this.appscenario = []
          this.attracting = []
          this.crms = []
        }
      })
      this.$router.push('/solution')
    }
  }
}
</script>
<style scoped>
.mindex {
  border-right: 3px solid #1e66d1;
  position: relative;
  right: -2px;
  color: #1e66d1;
  background: linear-gradient(to right, #e6e9ee, #fff);
}

.menu:hover {
  border-right: 3px solid #1e66d1;
  position: relative;
  right: -2px;
  color: #1e66d1;
  background: linear-gradient(to right, #e6e9ee, #fff);
}

.moindex {
  background: #fbfbfc !important;
}

.mokuai {
  /* border-left: 1px solid #fbfbfc;
  border-right: 1px solid #fbfbfc; */
}

.mokuai:hover {
  background: #fbfbfc !important;
  border-left: 1px solid #f2f3f5;
  border-right: 1px solid #f2f3f5;
}

.sanjx {
  width: 0;
  height: 0;
  border-bottom: 40px solid #1e66d1;
  border-left: 40px solid transparent;
  border-right: 40px solid transparent;
  position: absolute;
  bottom: -15px;
  left: 110px;
}
</style>